import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import BuyNowTextBoxWithAdornments from "components/textBoxes/buyNow/BuyNowTextBoxWithAdornments";
import title from "assets/images/homePage/buyNowSection/title_addons.png";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {},
        title: {},
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function AddonsTitle(props: IProps) {
    const classes = useStyles();
    const { className, ...rest } = props;

    return (
        <BuyNowTextBoxWithAdornments
            className={clsx(className, classes.root)}
            titlePrefixComponent={<img src={title} style={{ maxWidth: 240, width: "100%" }} />}
            {...rest}
        >
            <Typography>
                Take your DIRT 5 experience up another notch with our content packs, filled with new
                cars, events, liveries, customisation items and much more!
            </Typography>
        </BuyNowTextBoxWithAdornments>
    );
}
